import { getBundesland, getOrt } from '../../../helpers/getOrt';
import { hasEnergietraegerRechner } from './hasEnergietraegerRechner';
import { checkAZ, getMessageParams, checkGewerbe, validateFieldCO2Scope3GueterKapital } from './validateField';
import { getEmissionsFaktorForTid } from '../../../main/functions/getEmmissionsFaktor';
import { toFixedDecimal } from '../../../core/formatter/formatNumber';
import { IDs } from '../../../helpers/IDs';
import * as Moment from 'moment';

function getAbrechnungstage(WFormData: any): void {
    const { abrechnungszeitraum_bis, abrechnungszeitraum_von } = WFormData.values;
    const tage: number = Moment.unix(abrechnungszeitraum_bis)
        .diff(Moment.unix(abrechnungszeitraum_von), 'days') + 1;
    WFormData.setValue('abrechnungstage', tage);
}

function getBundleValue(key: string, WFormData: any): string {
    const tid: number = WFormData.getValue(key) || null;
    return ((Array.isArray((WFormData.bundle || {})[key])
        ? WFormData.bundle[key]
        : [{ tid: tid, name: WFormData.getValue(`${key}_name`) }]
    ).find((item: any) => item.tid === tid) || {}).name || null;
}

function onFormChangeAlternativesSystemTabelle3(WFormData: any, component: React.Component): void {
    const { einsparung, investitionssumme } = WFormData.values;
    WFormData.setValue('rentabilitaet_der_investition', (+investitionssumme || 0) * 0);
    WFormData.setValue('kapitalrueckfluss', (+einsparung || 0) * 0);
}

function onFormChangeCO2Scope(WFormData: any, component: React.Component): void {
    const transportmittel: string = WFormData.getValue('transportmittel') || '';
    if (transportmittel !== 'krad' && !transportmittel.startsWith('pkw_')) {
        WFormData.setValue('kraftstoff', null);
    }
}

function onFormChangeCO2ScopeEmittenten(WFormData: any): void {
    if (WFormData.getValue('emissionsangabe') === 'emissionen_absolut') {
        WFormData.setValue('einheit', null);
        WFormData.setValue('menge', null);
        WFormData.setValue('faktor', null);
    } else if (WFormData.getValue('co2_gesamt')) {
        WFormData.setValue('co2_gesamt', null);
    }
}

function onFormChangeCO2ScopeGueterKapital(WFormData: any, component: React.Component | any): void {
    onFormChangeCO2ScopeGueterKapitalAutoOpenDialog(WFormData, component);
}

function onFormChangeCO2ScopeGueterKapitalAutoOpenDialog(WFormData: any, component: React.Component | any): void {
    if ((component || {}).props && component.triggerService) {
        const formData: any = WFormData.getAllValues();
        const formDataOld: any = component.props.dataItem;
        const timeout = component.props.layout === 'flowV2' ? 1000 /* Assistent */ : 1000 /* Komplex */;
        if ((formData.art_tid_orig || formData.art_tid) !== (formDataOld.art_tid_orig || formDataOld.art_tid)) {
            const message: string = validateFieldCO2Scope3GueterKapital('art_tid', formData.art_tid, WFormData);
            if (getMessageParams(message)) {
                console.log('Call WFormWarnOnClick', `${formData.tid}_art_tid`);
                setTimeout(() => component.triggerService.fire('WFormWarnOnClick', `${formData.tid}_art_tid`), timeout);
            }
        }
    }
}

function onFormChangeCO2ScopeReisen(WFormData: any): void {
    const hin_rueck = +WFormData.getValue('hin_rueck');
    const hin_rueck_name = WFormData.getValue('hin_rueck_name');
    const teilstrecken = +WFormData.getValue('teilstrecken');
    const transportmittel: string = WFormData.getValue('transportmittel') || null;
    if (teilstrecken !== 1 && hin_rueck === 2 && hin_rueck_name !== 'Nein') {
       // Siehe auch AssistentEntityForm.getFormKey()
       // 09.05.2026 Deaktiviert, da nicht mehr gewünscht
       // WFormData.setValue('teilstrecken', 1);
    }
    // WKETOOL-212: Bugfix Übernachtungsemission fehlt bei Nutzerspezifisch (user_specific)
    const firmenfzg = +WFormData.getValue('firmenfahrzeug');
    if (firmenfzg === 1) {
        WFormData.setValue('modus', null);
    }
    if (transportmittel === 'uebernachtung') {
        WFormData.setValue('teilstrecken', 2); // {2} Nein
        WFormData.setValue('uebernachtungen', 1); // {1} Ja
        WFormData.setValue('entfernung', 0);
    }
}

function onFormChangeCO2ScopePendeln(WFormData: any): void {
    const hin_rueck = +WFormData.getValue('hin_rueck');
    if (hin_rueck === 0) {
        // Bei einem neuen Datensatz automatisch der Wert "ja"
        WFormData.setValue('hin_rueck', 1);
    }
    // WKETOOL-203: Analog zu Scope 3.4, 3.6 und 3.9 soll bei Auswahl „Hinfahrt gleich Rückfahrt?“ „Nein“ die Auswahl „Teilstrecken erfassen?“ auf „Ja“ springen.
    // Letzte Anpassung -> WKETOOL-133: Dass Teilstrecken autmatisch aktiviert wird, sollte bei 3.7. nicht der Fall sein.
    const hin_rueck_name = WFormData.getValue('hin_rueck_name');
    const teilstrecken = +WFormData.getValue('teilstrecken');
    if (teilstrecken !== 1 && hin_rueck === 2 && hin_rueck_name !== 'Nein') {
        // Siehe auch AssistentEntityForm.getFormKey()
        WFormData.setValue('teilstrecken', 1);
    }
}

function onFormChangeCO2ScopeVorgelagert(WFormData: any): void {
    const art: string = WFormData.getValue('art') || null;
    const hin_rueck = +WFormData.getValue('hin_rueck');
    const hin_rueck_name = WFormData.getValue('hin_rueck_name');
    const teilstrecken = +WFormData.getValue('teilstrecken');
    const transportmittel_mobilitaet: string = WFormData.getValue('transportmittel_mobilitaet') || null;
    if (teilstrecken !== 1 && hin_rueck === 2 && hin_rueck_name !== 'Nein') {
        // WKETOOL-103: 457 & 458
        // Siehe auch AssistentEntityForm.getFormKey()
        WFormData.setValue('teilstrecken', 1);
    }
    if (art === 'mobilitaet' && transportmittel_mobilitaet === 'uebernachtung') {
        WFormData.setValue('teilstrecken', 2); // {2} Nein
        WFormData.setValue('uebernachtungen', 1); // {1} Ja
        WFormData.setValue('entfernung', 0);
    }
}

function onFormChangeCO2ScopeNachgelagert(WFormData: any): void {
    const art: string = WFormData.getValue('art') || null;
    const hin_rueck = +WFormData.getValue('hin_rueck');
    const hin_rueck_name = WFormData.getValue('hin_rueck_name');
    const teilstrecken = +WFormData.getValue('teilstrecken');
    const transportmittel: string = WFormData.getValue('transportmittel') || null;
    if (art === 'mobilitaet' && teilstrecken !== 1 && hin_rueck === 2 && hin_rueck_name !== 'Nein') {
        // WKETOOL-103: 457 & 458
        // Siehe auch AssistentEntityForm.getFormKey()
        WFormData.setValue('teilstrecken', 1);
    }
    if (art === 'mobilitaet' && transportmittel === 'uebernachtung') {
        WFormData.setValue('teilstrecken', 2); // {2} Nein
        WFormData.setValue('uebernachtungen', 1); // {1} Ja
        WFormData.setValue('entfernung', 0);
    }
}

function onFormChangeEigenstrom(WFormData: any, component: React.Component): void {
    // console.log('ES:', WFormData);
    const { gesamtproduktion_kwh, netzeinspeisung_kwh } = WFormData.values;

    if (gesamtproduktion_kwh && +gesamtproduktion_kwh > 0) {
        let eigenverbrauch_kwh = +gesamtproduktion_kwh - (netzeinspeisung_kwh ? +netzeinspeisung_kwh : 0);
        eigenverbrauch_kwh = Math.round(eigenverbrauch_kwh * 100) / 100;
        const eigenverbrauch_quote = Math.round((100 / +gesamtproduktion_kwh) * eigenverbrauch_kwh);
        WFormData.setValue('eigenverbrauch_kwh', eigenverbrauch_kwh);
        WFormData.setValue('eigenverbrauchsquote', eigenverbrauch_quote);
    } else {
        WFormData.setValue('eigenverbrauch_kwh', undefined);
        WFormData.setValue('eigenverbrauchsquote', undefined);
    }
}

function onFormChangeEnergiedaten(WFormData: any, component: React.Component | any): void {
    WFormData.setValue('datum', Moment().unix());
    const { abrechnungszeitraum_bis, abrechnungszeitraum_von } = WFormData.values;
    if (typeof abrechnungszeitraum_von === 'undefined' || typeof abrechnungszeitraum_bis === 'undefined') {
        return;
    }
    getAbrechnungstage(WFormData);
    onFormChangeAbrechnungszeitraumAutoOpenDialog(WFormData, component);
}

function onFormChangeAbrechnungszeitraumAutoOpenDialog(WFormData: any, component: React.Component | any): void {
    if (component && component.props && component.triggerService) {
        const formData = WFormData.getAllValues();
        const formDataOld = component.props.dataItem;
        const dataGlobal = component.props.data;
        const timeout = component.props.layout === 'flowV2' ? 1000 /* Assistent */ : 1000 /* Komplex */;
        if (formData.abrechnungszeitraum_von !== formDataOld.abrechnungszeitraum_von) {
            const vmsg_von = checkAZ('abrechnungszeitraum_von', formData.jahr, formData.abrechnungszeitraum_von, formData.abrechnungszeitraum_bis, dataGlobal);
            const sysTxtKey_von = (getMessageParams(vmsg_von) || {}).key;
            if (sysTxtKey_von) {
                console.log('Call WFormWarnOnClick', `${formData.tid}_abrechnungszeitraum_von`);
                setTimeout(() => component.triggerService.fire('WFormWarnOnClick', `${formData.tid}_abrechnungszeitraum_von`), timeout);
            }
        } else if (formData.abrechnungszeitraum_bis !== formDataOld.abrechnungszeitraum_bis) {
            const vmsg_bis = checkAZ('abrechnungszeitraum_bis', formData.jahr, formData.abrechnungszeitraum_von, formData.abrechnungszeitraum_bis, dataGlobal);
            const sysTxtKey_bis = (getMessageParams(vmsg_bis) || {}).key;
            if (sysTxtKey_bis) {
                console.log('Call WFormWarnOnClick', `${formData.tid}_abrechnungszeitraum_bis`);
                setTimeout(() => component.triggerService.fire('WFormWarnOnClick', `${formData.tid}_abrechnungszeitraum_bis`), timeout);
            }
        }
    }
}

function formatNumbersByFields(WFormData: any, fields: string[], dp = 2) {
    fields.forEach((k: string) => {
        const val = WFormData.getValue(k);
        if (typeof val === 'number') {
            const valf = Math.round(val * Math.pow(10, dp)) / Math.pow(10, dp);
            if (valf !== val) {
                // console.log(k, val, valf, dp);
                WFormData.setValue(k, valf);
            }
        }
    });
}

function onFormChangeStandort(WFormData: any, component: React.Component, dataGlobal: any): void {
    const plz: string = WFormData.getValue('plz') || null;
    const ort: string = WFormData.getValue('ort') || null;
    let checkPlz: string = WFormData.getValue('checkPlz') || null;
    if (!checkPlz && (plz + '').length === 5) {
        WFormData.setValue('checkPlz', plz);
        checkPlz = plz;
    }
    if ((plz + '').length === 5 && (plz !== checkPlz || !ort)) {
        WFormData.setValue('ort', getOrt(plz));
        WFormData.setValue('checkPlz', plz);
    }
    const energiedaten_erfassen = WFormData.getValue('energiedaten_erfassen');
    if (!energiedaten_erfassen) {
        WFormData.setValue('energiedaten_erfassen', 1);
    }
}

function onFormChangeUnternehmensdaten(WFormData: any, component: React.Component, dataGlobal: any): void {
    dataGlobal = dataGlobal || {};
    const formData = WFormData.getAllValues();
    const oldformData = (dataGlobal[IDs.ENT_UNTERNEHMENSDATEN] || [])[0] || {};
    // console.log(formData, oldformData);
    const plz: string = WFormData.getValue('plz') || null;
    const bundesland: string = getBundesland(plz);
    const bundesland_tid: number = ((dataGlobal[IDs.ENT_BUNDESLAND] || [])
        .find((item: any) => item.name === bundesland) || {}).tid || null;

    if (plz !== oldformData.plz) {
        WFormData.setValue('ort', getOrt(plz));
    }

    if (typeof WFormData.values.bundesland_orig === 'undefined') {
        WFormData.setValue('bundesland', bundesland_tid);
    } else {
        WFormData.setValue('bundesland', bundesland_tid);
        WFormData.setValue('bundesland_name', bundesland);
        WFormData.setValue('bundesland_orig', bundesland_tid);
    }

    if (
        formData.gewerk_tid_orig && oldformData.gewerk_tid_orig &&
        formData.gewerk_tid_orig !== oldformData.gewerk_tid_orig
    ) {
        WFormData.setValue('wz_tid', null);
        WFormData.setValue('wz_tid_orig', null);
    }

    // Gewerkprüfung für Steuer
    if (dataGlobal.MODUL_SELECTED === 'steuer') {
        onFormChangeUnternehmensdatenGewerkAutoOpenDialog(WFormData, component, dataGlobal);
    }
}

function onFormChangeUnternehmensdatenGewerkAutoOpenDialog(WFormData: any, component: React.Component | any, dataGlobal: any): void {
    if (component && component.props && component.triggerService) {
        const formData = WFormData.getAllValues();
        const formDataOld = component.props.dataItem || {};
        const timeout = component.props.layout === 'flowV2' ? 1500 /* Assistent */ : 1000 /* Komplex */;
        // console.log(formData, formDataOld);
        if (formData.gewerk_tid_orig !== formDataOld.gewerk_tid_orig || formData.wz_tid_orig !== formDataOld.wz_tid_orig) {
            const vmsg = checkGewerbe(formData, dataGlobal, undefined);
            const sysTxtKey = (getMessageParams(vmsg) || {}).key;
            if (sysTxtKey) {
                console.log('Call WFormWarnOnClick', `${formData.tid}_wz_tid`);
                setTimeout(() => component.triggerService.fire('WFormWarnOnClick', `${formData.tid}_wz_tid`), timeout);
            }
        }
    }
}

function onFormChangeStrom(WFormData: any, component: React.Component | any, dataGlobal: any): void {
    onFormChangeStromAutoOpenDialog(WFormData, component);

    dataGlobal = dataGlobal || {};
    const formData = WFormData.getAllValues();
    const formDataOld = component.props.dataItem;

    if (
        formData.strom_dritte_orig && formDataOld.strom_dritte_orig &&
        formData.strom_dritte_orig !== formDataOld.strom_dritte_orig
    ) {
        WFormData.setValue('weitergeleitete_strommenge_kwh', null);
    }

    if (
        formData.seperate_abrechnung_emobil_strom_orig && formDataOld.seperate_abrechnung_emobil_strom_orig &&
        formData.seperate_abrechnung_emobil_strom_orig !== formDataOld.seperate_abrechnung_emobil_strom_orig
    ) {
        WFormData.setValue('stromverbrauch_efahrzeuge', null);
    }
}

function onFormChangeStromAutoOpenDialog(WFormData: any, component: React.Component | any): void {
    // Siehe auch StromButtonWrapper
    if (component && component.props && component.triggerService) {
        const formData = WFormData.getAllValues();
        const formDataOld = component.props.dataItem;
        if (formData.abrechnungsmodus === 2 && formDataOld.abrechnungsmodus !== 2) {
            // Warten, bis buttonOnAction registriert wurde.
            // Inzwischen kann componentWillUnmount gefeuert werden, timeout nicht zu kurz.
            const timeout = component.props.layout === 'flowV2' ? 1000 /* Assistent */ : 1000 /* Komplex */;
            setTimeout(() => component.triggerService.fire('onAction', 'StromButtonWrapper'), timeout);
        }
    }
}

function onFormChangeWaerme(WFormData: any, component: React.Component | any, dataGlobal: any): void {
    // Siehe validCo2Emissionen() von DateneingabeEnergiedatenKomplexForm
    // Suche * 1000000000

    // onFormChangeWaermeAutoOpenDialog(WFormData, component); // Deaktiviert wegen WKETOOL-220: CL 582

    // Umrechnung kWh <--> MWh (CL 598)
    const einheit: string = getBundleValue('einheit_tid', WFormData);
    const formData = WFormData.getAllValues();
    const formDataOld = component.props.dataItem;
    const formConfig = component.state.formConfig;
    const jahr = component.props.jahr;

    if (formData.energietraeger_tid_orig === 7 /* Fernwärme */) {
        if (formData.einheit_tid_orig !== formDataOld.einheit_tid_orig
            || (!formData.einheit_tid_orig && formData.einheit_tid !== formDataOld.einheit_tid)
        ) {
            // console.log(formDataOld.einheit_tid_orig, '->', formData.einheit_tid_orig, einheit, formData.co2_emissionen);
            if (formData.co2_emissionen > 0) {
                // Von Benutzer angegebene co2_emissionen ist keine Umrechnung erforderlich.
                // if (einheit === 'kWh') {
                //     WFormData.setValue('co2_emissionen', formData.co2_emissionen / 1000);
                // } else if (einheit === 'MWh') {
                //     WFormData.setValue('co2_emissionen', formData.co2_emissionen * 1000);
                // }
            } else {
                // Placeholder
                const feldCo2 = formConfig.getItem('co2_emissionen');
                let emissionsfaktor: number = getEmissionsFaktorForTid(dataGlobal, jahr, formData.energietraeger_tid_orig);
                if (feldCo2 && emissionsfaktor > 0) {
                    if (einheit === 'kWh') {
                        feldCo2.placeholder = toFixedDecimal(emissionsfaktor * 1000000, 3);
                        component.setState({ formConfig });
                    } else if (einheit === 'MWh') {
                        feldCo2.placeholder = toFixedDecimal(emissionsfaktor * 1000000000, 0);
                        component.setState({ formConfig });
                    }
                }
            }
        }
    }

    // Wenn CO2-Emissionen nicht verfügbar ist, muss sein Wert gelöscht werden.
    // Siehe Zeile 175 in extractWaermeNeu.ts
    // const co2_emissionen_t = item.co2_emissionen || item.co2_emissionen === 0 ? item.co2_emissionen / 1000000 : null;
    // {7} Fernwärme, {11} Strom, {12} Sonstige Wärmeträger, {21} Fernkälte
    const energietraegerMitCo2 = [7, 11, 12, 21];
    if (
        energietraegerMitCo2.indexOf(formData.energietraeger_tid_orig) === -1
        && energietraegerMitCo2.indexOf(formDataOld.energietraeger_tid_orig) !== -1
    ) {
        WFormData.setValue('co2_emissionen', '');
    }

    if (
        formData.waerme_dritte_orig && formDataOld.waerme_dritte_orig &&
        formData.waerme_dritte_orig !== formDataOld.waerme_dritte_orig
    ) {
        WFormData.setValue('weitergeleitete_waermemenge_kwh', null);
    }
}

// Deaktiviert wegen WKETOOL-220: CL 582
// WKETOOL-220: CL 582 Der Rechner soll bei Wärme nun nicht mehr automatisch aufgehen.
function onFormChangeWaermeAutoOpenDialog(WFormData: any, component: React.Component | any): void {
    // Siehe auch WaermeButtonWrapper und OelButtonWrapper
    if (component && component.props && component.triggerService) {
        const formData = WFormData.getAllValues();
        const formDataOld = component.props.dataItem;
        const hasER = hasEnergietraegerRechner(formData);
        // console.log(hasER, formData, formDataOld);
        const timeout = component.props.layout === 'flowV2' ? 1000 /* Assistent */ : 1000 /* Komplex */;
        if (hasER) {
            // OelButtonWrapper
            if ((formData.energietraeger_tid_orig || formData.energietraeger_tid) > 0 && (formData.einheit_tid_orig || formData.einheit_tid) > 0) {
                if (formData.energietraeger_tid_orig !== formDataOld.energietraeger_tid_orig
                    || (!formData.energietraeger_tid_orig && formData.energietraeger_tid !== formDataOld.energietraeger_tid)
                    // || formData.einheit_tid_orig !== formDataOld.einheit_tid_orig
                    // || (!formData.einheit_tid_orig && formData.einheit_tid !== formDataOld.einheit_tid)
                    || (formData.einheit_tid && !formDataOld.einheit_tid)
                ) {
                    // Warten, bis buttonOnAction registriert wurde.
                    // Inzwischen kann componentWillUnmount gefeuert werden, timeout nicht zu kurz.
                    setTimeout(() => component.triggerService.fire('onAction', 'OelButtonWrapper'), timeout);
                }
            }
        } else {
            // WaermeButtonWrapper
            if (formData.abrechnungsmodus === 2 && (formData.energietraeger_tid_orig || formData.energietraeger_tid) > 0 && (formData.einheit_tid_orig || formData.einheit_tid) > 0) {
                if (formData.abrechnungsmodus !== formDataOld.abrechnungsmodus
                    || formData.energietraeger_tid_orig !== formDataOld.energietraeger_tid_orig
                    || (!formData.energietraeger_tid_orig && formData.energietraeger_tid !== formDataOld.energietraeger_tid)
                    // || formData.einheit_tid_orig !== formDataOld.einheit_tid_orig
                    // || (!formData.einheit_tid_orig && formData.einheit_tid !== formDataOld.einheit_tid)
                    || (formData.einheit_tid && !formDataOld.einheit_tid)
                ) {
                    // Warten, bis buttonOnAction registriert wurde.
                    // Inzwischen kann componentWillUnmount gefeuert werden, timeout nicht zu kurz.
                    setTimeout(() => component.triggerService.fire('onAction', 'WaermeButtonWrapper'), timeout);
                }
            }
        }
    }
}

function onFormChangeWasser(WFormData: any, component: React.Component | any): void {
    const modul: string = component.props.data.MODUL_SELECTED || null;
    if (((component || {}).props || {}).layout === 'sidebysideComplex') {
        return;
    }
    const einheit: string = getBundleValue('einheit_tid', WFormData);
    const einheit2: string = getBundleValue('einheit2_tid', WFormData);
    const einheit_regen_tid: number = WFormData.getValue('einheit_regen_tid') || null;
    const einheit_regen_name: string = getBundleValue('einheit_regen_tid', WFormData);
    const verbrauch2: number = WFormData.getValue('verbrauch2') || null;
    const weitere_wasserquellen: number = WFormData.getValue('weitere_wasserquellen') || null;
    const regen_brunnennutzung: number = WFormData.getValue('regen_brunnennutzung') || null;
    const isActive: boolean = (+WFormData.getValue(`${weitere_wasserquellen}_orig`)
        || +WFormData.getValue('weitere_wasserquellen')) === 1 || WFormData.getValue('weitere_wasserquellen') === 'Ja';
    WFormData.setLabelExtra('fremdbezug', einheit ? ` [${einheit}]` : null);
    WFormData.setLabelExtra('regen_brunnennutzung', einheit_regen_name ? ` [${einheit_regen_name}]` : null);
    WFormData.setLabelExtra('abwasser', einheit ? ` [${einheit}]` : null);
    WFormData.setLabelExtra('verbrauch2', einheit2 ? ` [${einheit2}]` : null);
    WFormData.setLabelExtra('abwasser2', einheit2 ? ` [${einheit2}]` : null);

    if (modul === 'cfm' && !WFormData.getValue('weitere_wasserquellen') && verbrauch2 === null && regen_brunnennutzung !== null) {
        WFormData.setValue('verbrauch2', regen_brunnennutzung);
        WFormData.setValue('weitere_wasserquellen', 1);
        WFormData.setValue('weitere_wasserquellen_name', 'Ja');
        WFormData.setValue('weitere_wasserquellen_orig', 1);
        WFormData.setValue('einheit2_tid', einheit_regen_tid);

        if (typeof ((component || {}).props || {}).onChange === 'function') {
            component.props.onChange(IDs.ENT_ENERGIEDATEN_WASSER, WFormData.values, null, 0);
        }
        /*} else if (modul === 'cfm' && isActive && verbrauch2 !== regen_brunnennutzung) {
            WFormData.setValue('regen_brunnennutzung', verbrauch2);

            if (typeof ((component || {}).props || {}).onChange === 'function') {
                component.props.onChange(IDs.ENT_ENERGIEDATEN_WASSER, WFormData.values, null, 0);
            }
        } else if (modul !== 'cfm' && regen_brunnennutzung !== verbrauch2) {
            WFormData.setValue('verbrauch2', regen_brunnennutzung);

            if (typeof ((component || {}).props || {}).onChange === 'function') {
                component.props.onChange(IDs.ENT_ENERGIEDATEN_WASSER, WFormData.values, null, 0);
            }*/
    }
}

function onFormChangeCfmMotivation(WFormData: any, oldFormValues: any): void {
    const informed: boolean = WFormData.getValue('_SYS_INFORMED') || false;
    const konsolidierungsansatz: string = WFormData.getValue('konsolidierungsansatz') || null;
    const prevKonsolidierungsansatz: string = (oldFormValues || {}).konsolidierungsansatz || konsolidierungsansatz || null;
    const tid: number = WFormData.getValue('tid') || null;
    if (!konsolidierungsansatz) {
        WFormData.setValue('konsolidierungsansatz', 'operative_kontrolle');
    } else if (konsolidierungsansatz !== 'operative_kontrolle'
        && (prevKonsolidierungsansatz !== konsolidierungsansatz || (!tid && !informed))
    ) {
        alert('Achtung: Das E-Tool ist speziell auf den Ansatz der „Operativen Kontrolle“ ausgerichtet. Sollten Sie für die Auswahl Ihrer Bilanzgrenzen einen anderen Kontrollansatz verwenden, müssen Sie darauf achten, jeweils nur die für Sie relevanten Daten zu erfassen. Mehr Informationen zu den Kontrollansätzen finden Sie im Infofenster.');
        WFormData.setValue('_SYS_INFORMED', !tid && !informed);
    }
}

function onFormChangeEEDUmfrage(WFormData: any, component: React.Component | any, dataGlobal: any): void {
    // const formData = WFormData.getAllValues();
    // const formDataOld = component.props.dataItem;
}

export function onFormChangeUniversal(entity: string, WFormData: any, component: React.Component, dataGlobal?: any, oldFormValues?: any): void {
    // console.log('onFormChangeUniversal', entity);
    switch (entity) {
        case IDs.ENT_ALTERNATIVES_SYSTEM_TABELLE3:
            onFormChangeAlternativesSystemTabelle3(WFormData, component);
            break;
        case IDs.ENT_CO2_SCOPE3_EMITTENTEN:
            onFormChangeCO2ScopeEmittenten(WFormData);
            break;
        case IDs.ENT_CO2_SCOPE3_GUETER_KAPITAL:
            onFormChangeCO2ScopeGueterKapital(WFormData, component);
            break;
        case IDs.ENT_CO2_SCOPE3_PENDELN:
            onFormChangeCO2Scope(WFormData, component);
            onFormChangeCO2ScopePendeln(WFormData);
            break;
        case IDs.ENT_CO2_SCOPE3_REISEN:
            onFormChangeCO2Scope(WFormData, component);
            onFormChangeCO2ScopeReisen(WFormData);
            break;
        case IDs.ENT_CO2_SCOPE3_TRANSPORT_VORGELAGERT:
            onFormChangeCO2Scope(WFormData, component);
            onFormChangeCO2ScopeVorgelagert(WFormData);
            break;
        case IDs.ENT_CO2_SCOPE3_TRANSPORT_NACHGELAGERT:
            onFormChangeCO2Scope(WFormData, component);
            onFormChangeCO2ScopeNachgelagert(WFormData);
            break;
        case IDs.ENT_ENERGIEDATEN_EIGENSTROM:
            onFormChangeEnergiedaten(WFormData, component);
            onFormChangeEigenstrom(WFormData, component);
            break;
        case IDs.ENT_ENERGIEDATEN_KRAFTSTOFFE:
            onFormChangeEnergiedaten(WFormData, component);
            formatNumbersByFields(WFormData, ['verbrauch', 'kosten'], 2);
            break;
        case IDs.ENT_ENERGIEDATEN_STROM:
            onFormChangeEnergiedaten(WFormData, component);
            onFormChangeStrom(WFormData, component, dataGlobal);
            break;
        case IDs.ENT_ENERGIEDATEN_WAERME:
            onFormChangeEnergiedaten(WFormData, component);
            onFormChangeWaerme(WFormData, component, dataGlobal);
            formatNumbersByFields(WFormData, ['verbrauch', 'kosten'], 2);
            formatNumbersByFields(WFormData, ['co2_emissionen'], 3);
            break;
        case IDs.ENT_ENERGIEDATEN_WASSER:
            onFormChangeEnergiedaten(WFormData, component);
            onFormChangeWasser(WFormData, component);
            break;
        case IDs.ENT_STANDORT:
            onFormChangeStandort(WFormData, component, dataGlobal);
            break;
        case IDs.ENT_UNTERNEHMENSDATEN:
            onFormChangeUnternehmensdaten(WFormData, component, dataGlobal);
            break;
        case IDs.ENT_CFM_MOTIVATION:
            onFormChangeCfmMotivation(WFormData, oldFormValues);
            break;
        case IDs.ENT_EED_UMFRAGE:
            onFormChangeEEDUmfrage(WFormData, oldFormValues, dataGlobal);
            break;
    }
}
